import type { GlyphColor, IconName } from "../components/tk";

export type NavItem = {
  key: string;
  to: string;
  label: string;
  icon: IconName;
  color: GlyphColor;
  /** Primary destination. */
  primary?: boolean;
  /** Phone bottom tab. */
  tab?: boolean;
  /** Hidden for client viewers. */
  staff?: boolean;
  keywords?: string;
};

export const NAV: NavItem[] = [
  { key: "home", to: "/", label: "Home", icon: "home", color: "blue", primary: true, tab: true, keywords: "overview dashboard digest" },
  { key: "approvals", to: "/approvals", label: "Approvals", icon: "inbox", color: "orange", staff: true, keywords: "plans pending diff approve" },
  { key: "copilot", to: "/copilot", label: "Assistant", icon: "sparkles", color: "purple", primary: true, tab: true, staff: true, keywords: "copilot chat ask ai approvals automation" },
  { key: "ads", to: "/ads", label: "Ads", icon: "megaphone", color: "red", keywords: "ads table cpm pause" },
  { key: "campaigns", to: "/campaigns", label: "Campaigns", icon: "target", color: "green", primary: true, tab: true, keywords: "autopilot launch wizard" },
  { key: "results", to: "/results", label: "Results", icon: "chart", color: "blue", primary: true, tab: true, keywords: "performance overview metrics spend reporting" },
  { key: "rules", to: "/rules", label: "Rules", icon: "flow", color: "teal", staff: true, keywords: "automation conditions" },
  { key: "agents", to: "/agents", label: "Agents", icon: "robot", color: "indigo", staff: true, keywords: "night watch auditor treasurer runs findings" },
  { key: "attribution", to: "/attribution", label: "Revenue", icon: "chart", color: "pink", keywords: "roas retention sdk revenue" },
  { key: "channels", to: "/channels", label: "Channels", icon: "channel", color: "blue", keywords: "lookalikes database joins" },
  { key: "agency", to: "/agency", label: "Clients & reports", icon: "briefcase", color: "yellow", staff: true, keywords: "agency clients reports share transfers" },
  { key: "billing", to: "/billing", label: "Billing", icon: "wallet", color: "green", staff: true, keywords: "balance plan runway ledger" },
  { key: "settings", to: "/settings", label: "Settings", icon: "gear", color: "gray", keywords: "members notifications emergency pause" },
];

export function activeKey(pathname: string): string {
  if (pathname === "/" || pathname === "") return "home";
  const seg = pathname.split("/")[1] ?? "";
  if (seg === "more" || seg === "notifications") return seg;
  return NAV.find((n) => n.to === `/${seg}`)?.key ?? "";
}

/** The four daily destinations; secondary routes keep their parent selected. */
export function navGroup(pathname: string): string {
  const key = activeKey(pathname);
  if (["campaigns", "ads", "channels"].includes(key)) return "campaigns";
  if (["results", "attribution"].includes(key)) return "results";
  if (["copilot", "approvals", "rules", "agents"].includes(key)) return "copilot";
  if (["settings", "billing", "agency", "more"].includes(key)) return "workspace";
  return "home";
}

export const SECTION_LINKS: Record<string, { to: string; label: string }[]> = {
  campaigns: [{ to: "/campaigns", label: "Campaigns" }, { to: "/ads", label: "Ads" }, { to: "/channels", label: "Channels" }],
  copilot: [{ to: "/copilot", label: "Chat" }, { to: "/approvals", label: "Approvals" }, { to: "/rules", label: "Rules" }, { to: "/agents", label: "Agents" }],
  results: [{ to: "/results", label: "Overview" }, { to: "/attribution", label: "Revenue" }, { to: "/attribution/retention", label: "Retention" }, { to: "/attribution/sdk", label: "Tracking" }],
};
